<template>
  <main class="main">
    <template v-if="submitted">
      <div class="content">
        <header-bar />
        <div class="thanks">
          <submitted />
        </div>
      </div>
    </template>

    <template v-else-if="expired">
      <div class="content">
        <header-bar />
        <div class="thanks"><h1>URLの有効期限が切れています。</h1></div>
      </div>
    </template>

    <template v-else-if="code_error">
      <div class="content">
        <header-bar />
        <div class="thanks"><h1>無効なURL/無効な操作です。</h1></div>
      </div>
    </template>

    <template v-if="!submitted && !expired && !code_error && !loading">
      <div v-if="templateType !== 'thanks' && !user_submitted" class="content">
        <header-bar :templateType="'info'" />
        <form-btns></form-btns>
      </div>
      <div v-else-if="templateType !== 'thanks' && user_submitted">
        <div class="thanks">
          <submitted />
        </div>
      </div>
      <div v-else-if="templateType == 'thanks'" class="content">
        <header-bar />
        <div class="thanks">
          <h1>送信が完了しました。</h1>
          <p class="mailcheck">自動返信メールをご確認ください。</p>
        </div>
      </div>
      <!--/content-->
    </template>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import FormBtns from "@/components/FormBtns";
import HeaderBar from "@/components/HeaderBar";
import Submitted from "@/components/Submitted";

export default {
  data() {
    return {};
  },
  components: {
    FormBtns,
    HeaderBar,
    Submitted,
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "ispc",
      "current_offer",
      "user_submitted",
      "submitted",
      "expired",
      "code_error",
      "loading"
    ]),
  },
  methods: {},
  props: ["templateType"],
  name: "main-part"
};
</script>



// WEBPACK FOOTER //
// src/components/MainPart.vue